var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 179,
    viewBox: "0 0 137 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8112 15.3462C55.0298 19.9009 64.5144 23.7439 75.2153 28.0786C67.3999 36.6575 60.3867 44.3565 52.8818 52.5989C51.4196 47.2161 51.549 45.6245 49.4399 46.3103C48.1071 46.6726 46.6191 46.8538 45.364 47.4749C31.9975 54.0611 23.7939 70.5589 26.123 86.0086C28.7238 103.257 39.7094 115.071 55.5862 117.697C74.4778 120.829 92.9036 105.353 94.4822 85.064C95.2456 75.2818 93.2917 66.263 87.6113 58.0723C86.5244 56.5066 85.541 53.854 86.1103 52.3013C93.0071 33.6426 102.155 16.4461 119.585 5.29224C122.6 3.36426 126.016 2.07031 130.247 0C132.472 7.07788 134.452 13.3406 136.613 20.2114C126.003 24.8826 119.287 33.0862 113.607 42.4673C111.213 46.4268 111.213 49.5064 113.464 53.6729C127.297 79.2671 120.258 109.895 96.7983 127.583C73.3003 145.297 40.1494 143.641 18.9545 123.688C-2.39557 103.619 -6.16095 72.2022 9.96162 48.3159C16.7807 38.2102 25.8383 30.6924 37.3156 26.513C42.1032 24.7661 46.2309 23.291 43.8112 15.3462Z",
    fill: "#FCA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1052 164.512C44.9758 173.104 39.0237 178.862 30.2636 178.823C21.8789 178.797 15.5644 172.509 15.5903 164.202C15.6162 155.701 22.3447 149.205 30.8977 149.399C39.1919 149.593 45.2217 156.011 45.0923 164.499L45.1052 164.512Z",
    fill: "#FCA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1697 178.81C82.8497 178.746 76.4576 172.354 76.4964 164.137C76.5481 156.037 83.1473 149.451 91.2991 149.399C99.8651 149.347 106.27 155.92 106.102 164.59C105.934 173.065 99.8262 178.888 91.1568 178.81H91.1697Z",
    fill: "#FCA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.b61d4bdbbcac81bfec9bd7b7266fc3c5.svg";
export { ForwardRef as ReactComponent };